export default "__VITE_ASSET__b6838214__"